module.exports = __webpack_public_path__ + "static/io-525f5d185080767d6fb5abd58020694c.png";